import React, { useMemo } from 'react';

import LeftNavBlock from '../../utility/left-nav-block';
import { useTranslation } from '../../../hooks/useTranslation';
import ROUTES from '../../../routes';
import LeftNavMenu from '../../left-menu-navigation';

const ViewBillLeftPane = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => [
      {
        labels: t('BILLING_AND_PAYMENT'),
        menuOpen: true,
        items: [
          {
            labels: t('PAY_BILL'),
            url: ROUTES.PAYMENT,
            menuOpen: false,
          },
          {
            labels: t('AUTO_PAY'),
            url: ROUTES.AUTO_PAY,
            menuOpen: false,
          },
          {
            labels: t('VIEW_BILL_DETAILS'),
            url: ROUTES.VIEW_BILL,
            menuOpen: false,
          },
          {
            labels: t('EQUAL_PAY_TITLE'),
            url: ROUTES.EQUAL_PAY,
            menuOpen: false,
          },
          {
            labels: t('BILLING_PAYMENT_HISTORY_SIDE_MENU'),
            url: ROUTES.PAYMENT_HISTORY,
            menuOpen: false,
          },
          {
            labels: t('NMTTP'),
            url: ROUTES.NEED_MORE_TIME_TO_PAY,
            menuOpen: false,
          },
          {
            labels: t('MULTI_PAY'),
            url: ROUTES.MULTI_PAY,
            menuOpen: false,
          },
          {
            labels: t('VIEW_AND_DOWNLOAD_BILLS'),
            url: ROUTES.DOWNLOAD_MULTIPLE_BILLS,
            menuOpen: false,
          },
          {
            labels: t('PAPERLESS_BILLING'),
            url: ROUTES.PAPERLESS_BILLING,
            menuOpen: false,
          },
          {
            labels: t('PDD_PAGE_TITLE'),
            url: ROUTES.PREFERRED_DUE_DAY,
            menuOpen: false,
          },
          {
            labels: t('BILLING_OPTIONS_SIDE_MENU'),
            url: ROUTES.PAYMENT_OPTIONS,
            menuOpen: false,
          },
          {
            labels: t('UNDERSTAND_BILL'),
            url: ROUTES.UNDERSTANDING_MY_BILL,
            menuOpen: false,
          },
        ],
      },
    ],
    [],
  );
  const selectedLinkRoute =
    location.pathname === ROUTES.PAYMENT ? ROUTES.PAYMENT : location.pathname;
  return (
    <LeftNavMenu leftNavMenuItems={data} selectedItem={selectedLinkRoute} />
  );
};

export default ViewBillLeftPane;
